import { ResourceIdentifier } from "../ResourceManager/ResourceIdentifier";
import { Size } from ".././MyHelpers";
import { MyCanvas } from "./MyCanvas";
import { ZIndex } from "../ZIndex";
import { Scale } from ".././MyHelpers";

export class BigWinCountAnimation
{
	protected resid: ResourceIdentifier;
	protected canvas: MyCanvas;

	protected textSize: number;
	protected strokeSize: number;

	protected charWidth: number[] = [];
	protected maxWidth: number = 0;

	protected gradient: CanvasGradient;
	protected gradient2: CanvasGradient;

	protected fontFamily: string;
	protected textSpaceFactor: number = 1.15;

	protected color1Gradient: string;
	protected color2Gradient: string;

	protected colorInner: string;
	protected colorOuter: string;


	constructor(resid: ResourceIdentifier, size: Size, textSize: number, fontFamily: string) {
		this.resid = resid.Add("BigWinCount");
		this.fontFamily = fontFamily;
		
		this.textSize = textSize;
		this.strokeSize = this.textSize / 7;

		this.charWidth = [];
		this.maxWidth = 0;

		this.canvas = new MyCanvas(size, {
			classes: [this.resid.Scope()],
			style: {
			
				visibility : "hidden",
				zIndex : "" + ZIndex.WinCount,
			}
			
		});
		
		this.canvas.context.font = "" + this.textSize + "px \"" + this.fontFamily + "\"";
		this.canvas.context.textAlign = "center";
		this.canvas.context.textBaseline = "middle";

		for (let i = 0; i < 10; i++) {
			let w: number = this.canvas.context.measureText("" + i).width;
			//charWidth.push(w);
			if (w > this.maxWidth) this.maxWidth = w;
		}

		this.maxWidth = (this.maxWidth * this.textSpaceFactor);// + this.strokeSize;

	    this.AddGradient("orangered", "yellow", "black", "white", Scale.fh(22));

	 //    this.gradient2 = this.canvas.context.createLinearGradient(
		// 	this.canvas.size.width /2, // - tm.width /2, 
		// 	this.canvas.size.height /2 - this.textSize/2, 
		// 	this.canvas.size.width /2, // - tm.width /2, 
		// 	this.canvas.size.height /2 + this.textSize/2
		// );

	 //    this.gradient2.addColorStop(0, "yellow");
	 //    this.gradient2.addColorStop(0.66, "#d87a16");
	 //    this.gradient2.addColorStop(1, "yellow");

	    this.canvas.context.strokeStyle = "#c15218";
	    this.canvas.context.lineJoin="round"; //Experiment with "bevel" & "round" for the effect you want!
		this.canvas.context.miterLimit=2;

		this.canvas.view.classList.add("BigWinCountAnimation");
		this.canvas.view.style.visibility = "hidden";
		this.canvas.view.style.zIndex = ""+ZIndex.WinCount;
	}

	public AddGradient(color1Gradient:string, color2Gradient:string, colorInner: string, colorOuter:string, strokeSize:number):void{
		

		this.color1Gradient = color1Gradient;
		this.color2Gradient = color2Gradient;

		this.colorInner = colorInner;
		this.colorOuter = colorOuter;
		this.strokeSize = Scale.fh(strokeSize);

		this.gradient = this.canvas.context.createLinearGradient(
			this.canvas.size.Width /2, // - tm.width /2, 
			this.canvas.size.Height /2 - this.textSize/2, 
			this.canvas.size.Width /2, // - tm.width /2, 
			this.canvas.size.Height /2 + this.textSize/2
		);

	    this.gradient.addColorStop(0, color1Gradient);
	    this.gradient.addColorStop(0.70, color2Gradient);
	    this.gradient.addColorStop(1, color1Gradient);		
	}

	public Display(n: number): void {

		
		let textPositionX = this.canvas.size.Width / 2;
		let textPositionY = this.canvas.size.Height / 2;

		let numbersAsText = "" + n;
		let textWidth = numbersAsText.length * this.maxWidth;

	    this.canvas.context.fillStyle = this.gradient;
	    let startx = this.canvas.size.Width / 2 - textWidth  /2;

	    let numbers: number[] = [];

	    for (let i = 0; i < numbersAsText.length; i++) {
	    	numbers.push(parseInt(numbersAsText[i]));
	    }

	    this.canvas.context.clearRect(0, 0, this.canvas.size.Width, this.canvas.size.Height);
		this.AddGradient("orangered", "yellow", "black", "white", Scale.fh(22));
		this.canvas.context.strokeStyle = "#c15218";
	    this.canvas.context.lineJoin="round"; //Experiment with "bevel" & "round" for the effect you want!
		this.canvas.context.miterLimit=2;
		this.canvas.context.font = "" + this.textSize + "px \"" + this.fontFamily + "\"";
		this.canvas.context.textAlign = "center";
		this.canvas.context.textBaseline = "middle";


		for (let i = 0 ; i < numbers.length; i++) {

			let x = startx + (i * this.maxWidth) + (this.maxWidth / 2);
			let y = this.canvas.size.Height / 2;

			//this.canvas.context.rect(x - this.maxWidth /2, y - this.textSize/2, this.maxWidth, this.textSize);
			//this.canvas.context.lineWidth = 1;
			//this.canvas.context.stroke();



			this.canvas.context.strokeStyle = this.colorInner;
			this.canvas.context.lineWidth = this.strokeSize;
			this.canvas.context.strokeText("" + numbers[i], x, y);

			this.canvas.context.strokeStyle = this.colorOuter;
			this.canvas.context.lineWidth = this.strokeSize /4;
			this.canvas.context.strokeText("" + numbers[i], x, y);

			this.canvas.context.fillText("" + numbers[i], x, y);
			this.canvas.RestoreContext();
		}

		this.gradient = null;		
		this.gradient2 = null;
		this.colorInner = null;
		this.colorOuter = null;
		this.strokeSize = null;
		this.color1Gradient = null;
		this.color2Gradient = null;
	}

	public View(): HTMLElement {
		return this.canvas.view;
	}

	public Update(n : number){
		if(this.canvas.WasContextLost()){
			this.Display(n);
		}
	}
}